import * as React from "react";
import styled from "styled-components";
import { Icon } from "components/common";
import ClipboardButton from "components/common/ClipboardButton";
import useProductName from "brand-customization/useProductName";
const Container = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const IconContainer = styled.div`
  margin: 3px 15px 0 0;
`;
const Description = styled.div`
  max-width: 700px;
`;
const Row = styled.div`
  margin-bottom: 5px;

  &:last-child {
    margin-bottom: 0;
  }
`;
const OrderedList = styled.ol`
  padding: 0;
  list-style: decimal inside none;
`;
const UnknownWidget = ({ config, type }) => {
  const productName = useProductName();
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(IconContainer, null, /* @__PURE__ */ React.createElement(Icon, { name: "help", size: "3x" })), /* @__PURE__ */ React.createElement(Description, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement("strong", null, "Unknown Widget: ", type)), /* @__PURE__ */ React.createElement(Row, null, "Unfortunately we are not able to render this widget, because we do not know how to handle widgets of type", " ", /* @__PURE__ */ React.createElement("strong", null, type), ". This might be caused by one of these situations:"), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(OrderedList, null, /* @__PURE__ */ React.createElement("li", null, "You created this widget using a plugin that is now missing."), /* @__PURE__ */ React.createElement("li", null, "This widget was part of a legacy dashboard and created by a plugin that is not available anymore."))), /* @__PURE__ */ React.createElement(Row, null, "What can you do about it? You can load the plugin again, contact the original plugin author for a plugin that works with the current version of ", productName, ", or remove the widget if you do not need it anymore."), /* @__PURE__ */ React.createElement(Row, null, "Either way, you can copy the widget\u2019s config to the clipboard:", " ", /* @__PURE__ */ React.createElement(
    ClipboardButton,
    {
      title: /* @__PURE__ */ React.createElement(Icon, { name: "content_copy", size: "sm" }),
      text: JSON.stringify(config, null, 2),
      bsSize: "xsmall"
    }
  ))));
};
export default UnknownWidget;
